import React, { Component } from 'react'
import ThemeContext from './../../context/ThemeContext';
import { Link, graphql, StaticQuery } from 'gatsby';
import { HeaderLink } from './../links/HeaderLink';
import { Spring, Transition, animated as a } from "react-spring";
import TypewriterText from './../typewriter/TypewriterText';
import TypewriterTextBksp from './../typewriter/TypewriterTextBksp';

class LeftMenu extends Component {

  constructor(props) {
    super(props);
  }

  state = {
    menuOpen: false,
    buildInfo: false,
  }

  toggleMenu() {
    this.setState({menuOpen: !this.state.menuOpen})
  }

  handleMouseOver(event) {
    console.log("inside mouse over");


    this.setState({buildInfo: true})

  }

  render(){
    
    return (
      <ThemeContext.Consumer>
        {theme => (
          <>
            <Link to="/">
              <div size="12" className={`styles__Logo-sc-1mju43i-1  tonye ${theme.menuExpanded ? "expanded" : "closed"} ${this.props.leftLogo ? "iGGtiG": "fLaXQl"}`}>
                {theme.menuExpanded ? 
                  <HeaderLink text="" className=" expanded">
                    <TypewriterText 
                      // back={true} 
                      // delay={1400}
                      text="Tonye" 
                    />
                  </HeaderLink>
                  :
                  <HeaderLink text="" className=" header-logo" >
                    {this.props.leftLogo ?
                      <TypewriterTextBksp 
                        // back={true} 
                        text={theme.menuExpanded ? "Tonye" : "T"} 
                      />
                      :
                      <TypewriterText 
                        // back={false} 
                        // delay={1400}
                        text="Tonye" 
                      />
                    }
                  </HeaderLink>
                }
              </div>
            </Link>
 
            {/* <svg className={theme.menuExpanded ? "expanded active":"erase"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 234.88 124.06" width="77" height="124.05999755859375"><title>Asset 10</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><polygon class="cls-1 svg-elem-1" points="55.41 0.5 55.41 19.93 80.56 19.9 80.56 123.56 104.55 123.56 104.55 19.9 129.69 19.93 129.69 0.5 55.41 0.5"></polygon><polygon class="cls-2 svg-elem-2" points="190.67 36.8 200.54 36.8 178.99 99.78 169.16 99.78 190.67 36.8"></polygon><polygon class="cls-2 svg-elem-3" points="25.39 49.05 0.5 69.27 0.5 74.93 25.41 95.63 25.41 84.29 10.68 72.08 25.42 60.39 25.39 49.05"></polygon><polygon class="cls-2 svg-elem-4" points="209.48 49 234.38 69.21 234.38 74.87 209.46 95.57 209.46 84.24 224.2 72.03 209.45 60.33 209.48 49"></polygon></g></g></svg> */}

            <button
              id="navToggle"
              aria-label="menu toggle"
              aria-haspopup="true"
              aria-expanded={theme.toggleExpanded}
              aria-controls="navMenu"
              tabIndex="0"
              className={`fade-in Button-sc-1hlz05c-0 cEmjre ${theme.menuExpanded && "open"}`}
              onClick={() => this.toggleMenu()}
              onClick={theme.toggleExpanded}
            >
              <div>
                <div className={`Message-sc-1n51ew6-0 voOsr is-enter-done ${theme.menuExpanded && "expanded"}`}>Menu</div>  
                <div className="message Message-sc-1n51ew6-0 mbDfJ is-enter-done"> </div>
              </div>
              <svg
                viewBox="0 0 24 11"
                className={`styles__Burger-sc-1wbuqby-0 ${theme.menuExpanded ? "bEcPZs" : "iaeVuZ"}`}
                open={theme.menuExpanded}
              >
                <g fill="currentColor" stroke="currentColor">
                  <path d="M0,16 L24,16 L24,17 L0,17 L0,16 Z"></path>
                  <path d="M0,0 L24,0 L24,1 L0,1 L0,0 Z"></path>
                  <path d="M0,8 L24,8 L24,9 L0,9 L0,8 Z"></path>
                </g>
              </svg>
            </button>
            <nav
              className={`styles__Nav-sc-1rxowd7-0 ${theme.menuExpanded ? "bsAgBk nav-open" : "gGnjl"
              }`}
              id="navMenu"
              role="menu"
              aria-labelledby="navToggle"
              aria-expanded="true"
              open=""
            >
              <ul className="PrimaryList-znukt8-0 hlNPUQ">
                <li className={`PrimaryItem-sc-1y9k6jo-0 ${theme.menuExpanded && "aPxxy"}`}>
                  <a role="menuitem" href="/work">
                    <h2 className="TextNode-sc-1sjbvgs-0 Title-k0khhz-0 fCqQlh">
                      Work<span className="Arrow-sc-8j8gpl-0 bWDpBq"></span>
                    </h2>
                  </a>
                  <p className="TextNode-sc-1sjbvgs-0 Paragraph-o7a2lq-0 kOvbiq">
                    Take a look at what we've done.
                  </p>
                </li>
                <li className={`PrimaryItem-sc-1y9k6jo-0 ${theme.menuExpanded && "aPxxy"}`}>
                  <a role="menuitem" href="/posts">
                    <h2 className="TextNode-sc-1sjbvgs-0 Title-k0khhz-0 fCqQlh">
                      Blog<span className="Arrow-sc-8j8gpl-0 bWDpBq"></span>
                    </h2>
                  </a>
                  <p className="TextNode-sc-1sjbvgs-0 Paragraph-o7a2lq-0 kOvbiq">
                    My thoughts on many, many things.
                  </p>
                </li>
                <li className={`PrimaryItem-sc-1y9k6jo-0 ${theme.menuExpanded && "aPxxy"}`}>
                  <a role="menuitem" href="/about">
                    <h2 className="TextNode-sc-1sjbvgs-0 Title-k0khhz-0 fCqQlh">
                      About<span className="Arrow-sc-8j8gpl-0 bWDpBq"></span>
                    </h2>
                  </a>
                  <p className="TextNode-sc-1sjbvgs-0 Paragraph-o7a2lq-0 kOvbiq">
                    Learn what makes me special.
                  </p>
                </li>
              </ul>
              <ul>
                <li className="SecondaryItem-ym51j0-0 beSgWT">
                  <a
                    role="menuitem"
                    className="styles__Link-sc-1y1rqxu-1 hGNpXJ"
                    href="https://www.linkedin.com/in/bezalel/"
                  >
                    LinkedIn
                    <span className="Arrow-sc-8j8gpl-0 bWDpBq"></span>
                  </a>
                </li>
                <li className="SecondaryItem-ym51j0-0 beSgWT">
                  <a
                    role="menuitem"
                    className="styles__Link-sc-1y1rqxu-1 hGNpXJ"
                    href="/applications/"
                  >
                    Applications<span className="Arrow-sc-8j8gpl-0 bWDpBq"></span>
                  </a>
                </li>
                <li className="SecondaryItem-ym51j0-0 beSgWT">
                  <a
                    role="menuitem"
                    className="styles__Link-sc-1y1rqxu-1 hGNpXJ"
                    href="/contact"
                  >
                    Message Me
                    <span className="Arrow-sc-8j8gpl-0 bWDpBq"></span>
                  </a>
                </li>
              </ul>
              
              <div className="info-panel">
                <div className="dark-mode-container">
                  <span>⚙</span>
                </div>
                <div className="last-build">
                  <span onMouseOver={(e)=> this.handleMouseOver(e)}>i</span>
                  { this.state.buildInfo &&
                    <StaticQuery 
                      query={graphql`
                        query Info {
                          site {
                            buildTime(formatString: "DD/MM/YYYY")
                          }
                        }
                      `}
                      render={data => <>
                          <p className="info">This site was last built on: {data.site && data.site.buildTime}</p>
                        </>
                    }
                  />}
                </div>
              </div>
                
              {/* <svg className={theme.menuExpanded && "active"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 234.88 124.06" width="234.8800048828125" height="124.05999755859375"><title>Asset 10</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><polygon class="cls-1 svg-elem-1" points="55.41 0.5 55.41 19.93 80.56 19.9 80.56 123.56 104.55 123.56 104.55 19.9 129.69 19.93 129.69 0.5 55.41 0.5"></polygon><polygon class="cls-2 svg-elem-2" points="190.67 36.8 200.54 36.8 178.99 99.78 169.16 99.78 190.67 36.8"></polygon><polygon class="cls-2 svg-elem-3" points="25.39 49.05 0.5 69.27 0.5 74.93 25.41 95.63 25.41 84.29 10.68 72.08 25.42 60.39 25.39 49.05"></polygon><polygon class="cls-2 svg-elem-4" points="209.48 49 234.38 69.21 234.38 74.87 209.46 95.57 209.46 84.24 224.2 72.03 209.45 60.33 209.48 49"></polygon></g></g></svg> */}
            </nav>
          </>
        )}
      </ThemeContext.Consumer>
    )
  }
}

export default LeftMenu;